export const HOME_CITY_STORAGE_KEY = 'sporto_home_city';
export const DEFAULT_HOME_CITY_NAME = 'Jakarta Pusat';

export interface HomeCityValue {
  name: string;
  code?: string;
}

export function getStoredHomeCity(): HomeCityValue | null {
  if (typeof window === 'undefined' || !window.localStorage) {
    return null;
  }
  const raw = localStorage.getItem(HOME_CITY_STORAGE_KEY);
  if (!raw) {
    return null;
  }
  try {
    const parsed = JSON.parse(raw) as HomeCityValue;
    if (!parsed?.name || typeof parsed.name !== 'string') {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function setHomeCityName({ name, code }: HomeCityValue): void {
  if (typeof window === 'undefined' || !window.localStorage) {
    return;
  }
  const payload: HomeCityValue = { name };
  if (code) {
    payload.code = code;
  }
  localStorage.setItem(HOME_CITY_STORAGE_KEY, JSON.stringify(payload));
}

export function getHomeCityName({
  profileCityName,
}: {
  profileCityName?: string | null;
} = {}): string {
  return getStoredHomeCity()?.name || profileCityName || DEFAULT_HOME_CITY_NAME;
}
